'use client';

import * as React from 'react';
import { styled } from '@linaria/react';

import useSound from '@/hooks/use-sound';

import TextLink from '@/components/Link/TextLink';
import VisuallyHidden from '@/components/VisuallyHidden';
import PrideFlag from '@/post-helpers/pride-flags/PrideFlag';
import { COLORS } from '@/post-helpers/pride-flags/constants';

import { MOBILE_BREAKPOINT } from '../AboutJosh.constants';
import BaseChild from './BaseChild';

const RAINBOW_THEMES = Object.keys(COLORS);

type RainbowTheme = (typeof RAINBOW_THEMES)[number];

function CardGay(delegated: React.HTMLAttributes<HTMLDivElement>) {
  const [theme, setTheme] = React.useState<RainbowTheme>('rainbow');

  const [play] = useSound('/sounds/plunger-immediate.mp3', {
    volume: 0.27,
  });

  function toggleTheme() {
    setTheme((prevTheme) => {
      play();

      const currentIndex = RAINBOW_THEMES.indexOf(prevTheme);
      const nextIndex = currentIndex + 1;

      return RAINBOW_THEMES[nextIndex % RAINBOW_THEMES.length];
    });
  }

  return (
    <Wrapper {...delegated}>
      <FlagBtn onClick={toggleTheme}>
        {/* More TS issues, see below */}
        {/* @ts-ignore */}
        <StyledFlag aria-hidden="true" billow={4} variant={theme} />
        <VisuallyHidden>
          Rainbow flag. Triggering this button cycles through various
          pride flags. This is a purely cosmetic effect.
        </VisuallyHidden>
      </FlagBtn>
      <p>
        I'm a cis gay man, and my pronouns are <em>he/him</em>.
      </p>

      <p className="small">
        Want your own Pride flag? I have a{' '}
        <TextLink href="/animation/pride-flags">
          tutorial all about it
        </TextLink>
        !
      </p>
    </Wrapper>
  );
}

const Wrapper = styled(BaseChild)`
  --rainbow-black: hsl(210deg 10% 15%);

  html[data-color-mode='dark'] & {
    --rainbow-black: hsl(210deg 10% 19%);
  }

  @media (max-width: ${MOBILE_BREAKPOINT}rem) {
    html[data-color-mode='dark'] & {
      --rainbow-black: hsl(210deg 15% 10%);
    }
  }

  &:has(button:focus-visible) {
    outline: 2px solid var(--color-primary);
  }
`;

const FlagBtn = styled.button`
  margin: -32px auto 24px;
  width: 100px;
  max-width: 90%;
  aspect-ratio: 30 / 18;
  -webkit-tap-highlight-color: transparent;

  @supports selector(:has(*)) {
    &:focus-visible {
      outline: none;
    }
  }

  @media (max-width: ${MOBILE_BREAKPOINT}rem) {
    margin-top: 0;
  }
`;

// TypeScript struggles because the component is lazy-loaded, and it can't tell that it does in fact have a `className` prop.
// @ts-ignore
const StyledFlag = styled(PrideFlag)`
  --radius: 4px !important;
  width: 100%;
  height: 100%;
`;

export default CardGay;
